import type { ReviewStatus } from '@/types'

/**
 * The position of the next item to review: the first id at or after `from`
 * that still exists and is still pending. -1 when the queue is done.
 *
 * Checked against the live rows, not the snapshot, so an item a teammate
 * reviewed (or deleted) since the queue started is passed over.
 */
export function nextPending(
  queue: string[],
  from: number,
  byId: ReadonlyMap<string, { status: ReviewStatus }>,
): number {
  for (let i = Math.max(from, 0); i < queue.length; i++) {
    if (byId.get(queue[i]!)?.status === 'pending') return i
  }
  return -1
}

/** Pending items from `position` on, the shown one included. */
export function remainingFrom(
  queue: string[],
  position: number,
  byId: ReadonlyMap<string, { status: ReviewStatus }>,
): number {
  if (position < 0) return 0
  // The shown item counts even once its optimistic verdict lands, until the queue moves on.
  return 1 + queue.slice(position + 1).filter((id) => byId.get(id)?.status === 'pending').length
}
